import React ,  {useState , useEffect }from 'react';
import { Button, Modal, ModalHeader, ModalBody, Label, UncontrolledTooltip, Input, Row, Col, Accordion, AccordionItem,Collapse  } from 'reactstrap';
import config from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import AccordionItem_Component from './AccordionItem_Component';
import Dashboard_Favprompt_Item from './Dashboard_Favprompt_Item';
import Loader from '../../Components/Common/Loader';
import { fetch_chart_options } from '../../helpers/fakebackend_helper';
import { set_selected_fav_prompt_id_element, set_selected_labelling, set_selected_theta, set_selected_xaxis, set_selected_yaxis } from '../../slices/dashboard/reducer';
import { open_error_modal } from '../../slices/Error_Modal/reducer';
import { GET_ELEMENT_DATA } from '../../slices/dashboard/thunk';
import { uniqueId } from 'lodash';
import { v4 as uuidv4 } from "uuid";

const Create_Dashboard_Element = () => {

    const {  dashboard_loader , dashboard_list , fav_prompt_list , selected_xaxis_value , selected_yaxis_value , selected_labelling_value , selected_theta_value   }  = useSelector((state)=>state.Dashboard)
    const [modal_standard, setmodal_standard] = useState(false);
    const [xaxis_yaxis, setxaxis_yaxis] = useState(null)
    const [dashboard_element_title, set_dashboard_element_title] = useState(null)
    const [fav_prompt_grouped, setfav_prompt_grouped] = useState({})
    const { selected_fav_prompt_id_element , selected_fav_prompt_data} = useSelector((state)=>state.Dashboard)
    const [pie_chart_options_values, set_pie_chart_options_values] = useState(null)
    const [titleError, setTitleError] = useState(false);


    const [dashboard_data, setdashboard_data] = useState({})
    const [loading, setloading] = useState(false)

    useEffect(() => {
      if(dashboard_list.data){

        setdashboard_data(dashboard_list?.data[0])
      }
    }, [dashboard_list])
    
    const dispatch = useDispatch()
   


        function dashboard_Element() {
            setmodal_standard(!modal_standard);
            set_dashboard_element_title(null)
            dispatch(set_selected_fav_prompt_id_element(null))
        }
        const [col1, setcol1] = useState(false);
        const [selectedChart , setselectedChart ] = useState('bar')
 


        function groupByPromptCategory(data) {
  const grouped = {};

  data?.Prompt_wih_sql?.forEach(item => {
    const category = item.PromptCategory.trim(); // normalize by trimming spaces

    if (!grouped[category]) {
      grouped[category] = [];
    }

    grouped[category].push(item);
  });

  return grouped;
}

useEffect(() => {
  
    let grouped_values = groupByPromptCategory(fav_prompt_list)

    
setfav_prompt_grouped(grouped_values)
}, [fav_prompt_list])


//  const get_options_for_xaxis_yaxis = (chart_type)=>{
//                 setloading(true)
//                   fetch_chart_options({ visualization:chart_type , database_id:selected_fav_prompt_data.Database_Id , sql_query:selected_fav_prompt_data.PromptSQL }).then((data)=>{
//                     setloading(false)
//                      setxaxis_yaxis(data)
//                      dispatch(set_selected_xaxis(data.values_available_for_xaxis[0]))
//                      dispatch(set_selected_yaxis(data.values_available_for_yaxis[0]))
//                   }).catch((error)=>{
//                         setloading(false)
//                       console.log(error);
//                   })
//             }


            //  const get_options_for_theta_labelling = (chart_type)=>{
            //     setloading(true)
            //     fetch_chart_options({ visualization:chart_type , database_id:selected_fav_prompt_data.Database_Id , sql_query:selected_fav_prompt_data.PromptSQL }).then((data)=>{
            //         setloading(false)
            //          set_pie_chart_options_values(data)
            //          dispatch(set_selected_labelling(data.labelling_column_values[0]))
            //          dispatch(set_selected_theta(data.theta_column_value[0]))
            //       }).catch((error)=>{
            //         setloading(false)
            //           console.log(error);
            //       })
            // }



            // const get_options = (chart_type)=>{
            //     if(chart_type=='bar' || chart_type =='line' || chart_type=='bar') {
            //       get_options_for_xaxis_yaxis(chart_type)
            //     }
            //     if(chart_type=='pie'){
            //         get_options_for_theta_labelling(chart_type)
            //     }
            // }


        



            // useEffect(() => {
            //     if(selected_fav_prompt_id_element){

            //         get_options('bar')
            //     }
            // }, [selected_fav_prompt_id_element])

            
       

          
  return (
    <>
    {/* =============loader================ */}

      <Button color=" no_padding" id="cde" onClick={() => dashboard_Element()}>
        <i className="ri-add-box-line"></i>
      </Button>
      <UncontrolledTooltip placement="left" target="cde">
        {" "}
        {config.tool_tip.create_Dashboard_Element}{" "}
      </UncontrolledTooltip>
      {/* Default Modal */}
      <Modal
        id="myModal"
        isOpen={modal_standard}
        toggle={() => {
          dashboard_Element();
        }}
      >
        <ModalHeader
          className="modal-title"
          id="myModalLabel"
          toggle={() => {
            dashboard_Element();
          }}
        >
          Create A Dashboard Element
        </ModalHeader>
        {<ModalBody>
          <Row>
            <Col lg={6}>
              <div className="title">
                <Label>Title *</Label>
                <Input
                  value={dashboard_element_title}
                  onChange={(e) => {
                    set_dashboard_element_title(e.target.value);
                    setTitleError(false);
                  }}
                  type="text"
                  className={`form-control ${titleError ? "is-invalid" : ""}`}
                  id="title"
                />
                {titleError && <div className="invalid-feedback">Title is required.</div>}
              </div>
            </Col>
          </Row>
          <Row className="mt-30">
            <Col>
            
              <div className="fp_data">
                {
                // loading ? <Loader />: selected_fav_prompt_id_element !== null &&<div className="select_to_show_prompt">
                //   <div className="">
                //     <Label>Select a Chart:</Label>
                //   </div>
                //   <select
                //     id="chart-select"
                //     value={selectedChart}
                //     onChange={(e) => {
                //       setselectedChart(e.target.value);
              
                //         get_options(e.target.value);
                        
              
                //     }}
                //     className="border p-2 form-select"
                //   >
                //     <option value="bar">Bar Chart</option>
                //     <option value="pie">Pie Chart</option>
                //     <option value="line">Line Chart</option>
                //      <option value="table">Table</option>
                //   </select>

                //   {/* Conditional rendering of divs */}
                //   { selected_fav_prompt_id_element !== null && <>  {selectedChart === "bar" && (
                //     <Row className="mt-3">
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select x-axis</Label>
                //         </div>
                //         <select  onChange={(e)=>{
                //             dispatch(set_selected_xaxis(e.target.value))
                //         }} id="x-axis" className="border p-2 form-select">
                //           {xaxis_yaxis?.values_available_for_xaxis?.map(
                //             (element, index) => {
                //               return <option selected={selected_xaxis_value == element} value={element}>{element}</option>;
                //             }
                //           )}
                 
                //         </select>
                //       </Col>
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select y-axis</Label>
                //         </div>
                //         <select onChange={(e)=>{
                //             dispatch(set_selected_yaxis(e.target.value))
                //         }} id="y-axis" className="border p-2 form-select">
                //           {xaxis_yaxis?.values_available_for_yaxis?.map(
                //             (element, index) => {
                //               return <option selected={selected_yaxis_value == element} value={element}>{element}</option>;
                //             }
                //           )}
                //         </select>
                //       </Col>
                //     </Row>
                //   )}

                //   {selectedChart === "pie" && (
                //     <Row className="mt-3">
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select labelling</Label>
                //         </div>
                //         <select onChange={(e)=>{
                //             dispatch(set_selected_labelling(e.target.value))
                //         }} id="x-axis" className="border p-2 form-select">
                //           {pie_chart_options_values?.labelling_column_values?.map(
                //             (element, index) => {
                //               return <option selected={selected_labelling_value == element} value={element}>{element}</option>;
                //             }
                //           )}
                //         </select>
                //       </Col>
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select Theta</Label>
                //         </div>
                //         <select onChange={(e)=>{
                //             dispatch(set_selected_theta(e.target.value))
                //         }} id="y-axis" className="border p-2 form-select">
                //           {pie_chart_options_values?.theta_column_value?.map(
                //             (element, index) => {
                //               return <option selected={selected_theta_value == element} value={element}>{element}</option>;
                //             }
                //           )}
                //         </select>
                //       </Col>
                //     </Row>
                //   )}

                //   {selectedChart === "line" && (
                //     <Row className="mt-3">
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select x-axis</Label>
                //         </div>
                //         <select id="x-axis" className="border p-2 form-select">
                //           {xaxis_yaxis?.values_available_for_xaxis?.map(
                //             (element, index) => {
                //               return <option value={element}>{element}</option>;
                //             }
                //           )}
                //         </select>
                //       </Col>
                //       <Col lg={6}>
                //         <div className="">
                //           <Label>Select y-axis</Label>
                //         </div>
                //         <select id="y-axis" className="border p-2 form-select">
                //           {xaxis_yaxis?.values_available_for_yaxis?.map(
                //             (element, index) => {
                //               return <option value={element}>{element}</option>;
                //             }
                //           )}
                //         </select>
                //       </Col>
                //     </Row>
                //   )} </>}
                // </div>
                }
                <Accordion id="default-accordion-example">
                  <Label className="mt-3">
                    Select a favourite prompt data *
                  </Label>
                  {Object.entries(fav_prompt_grouped).map(([category, prompts]) => {
                    return (
                      <AccordionItem_Component key={category}
                        category={category}
                        prompts={prompts}
                      ></AccordionItem_Component>
                    );
                  })}
                </Accordion>
              </div>
            </Col>
          </Row>
        </ModalBody>}
        <div className="modal-footer justify-center">
          <Button
            color="light"
            onClick={() => {
              dashboard_Element();
            }}
          >
            Cancel
          </Button>
          <Button disabled={loading} color="secondary" onClick={() => {
  if (!dashboard_element_title?.trim()) {
    setTitleError(true);
    return;
  }

  setTitleError(false);
  // proceed with your logic for the next step
  
  if(!selected_fav_prompt_id_element){
    dispatch(open_error_modal("Select a Favuorite Prompt "))
    return
  }

   dispatch(GET_ELEMENT_DATA({
    
  "database_id": selected_fav_prompt_data.Database_Id,
  "dashboard_id":dashboard_data.Dashboard_Id,
  "title":dashboard_element_title,
  "graph_element_title":dashboard_element_title,
  "favorite_prompt_id":selected_fav_prompt_data.BotFavoritePromptId,
   "element_id":uuidv4()
  }))

//   if(selectedChart=='bar' || selectedChart=='line'){
//       dispatch(GET_ELEMENT_DATA({
    
//   "database_id": selected_fav_prompt_data.Database_Id,
//   "dashboard_id":dashboard_data.Dashboard_Id,
//   "sql_query": selected_fav_prompt_data.PromptSQL,
//   "visualization": selectedChart,
//     "x_axis": selected_xaxis_value, 
//   "y_axis": selected_yaxis_value,
//   "title":dashboard_element_title,
//   "graph_element_title":dashboard_element_title,
//   "favorite_prompt_id":selected_fav_prompt_data.BotFavoritePromptId,
//    "element_id":uniqueId()
//   }))
//   }

//   else if(selectedChart=='pie'){
// dispatch(GET_ELEMENT_DATA({
    
//   "database_id": selected_fav_prompt_data.Database_Id,
//   "dashboard_id":dashboard_data.Dashboard_Id,
//   "sql_query": selected_fav_prompt_data.PromptSQL,
//   "visualization": selectedChart,
//     "labelling_value": selected_labelling_value, 
//   "theta_value": selected_theta_value,
//   "title":dashboard_element_title,
//   "graph_element_title":dashboard_element_title,
//   "favorite_prompt_id":selected_fav_prompt_data.BotFavoritePromptId,
//    "element_id":uniqueId()

//   }))
//   }
//   else if(selectedChart=='table'){
// dispatch(GET_ELEMENT_DATA({
    
//   "database_id": selected_fav_prompt_data.Database_Id,
//   "dashboard_id":dashboard_data.Dashboard_Id,
//   "sql_query": selected_fav_prompt_data.PromptSQL,
//   "visualization": selectedChart,
//   "title":dashboard_element_title,
//   "graph_element_title":dashboard_element_title,
//   "favorite_prompt_id":selected_fav_prompt_data.BotFavoritePromptId,
//   "element_id":uniqueId()

//   }))
//   }
dashboard_Element()

}}>
  Next
</Button>
        </div>
      </Modal>
    </>
  );
}

export default Create_Dashboard_Element